import React, { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { Avatar, AvatarPropsType } from "../Avatar";

import styles from "./AvatarLabelGroup.styles.module.scss";

type AvatarGroupLabelSize = "sm" | "md" | "lg" | "xl";

export type AvatarLabelGroupPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  label?: ReactNode
  supportingText?: string
  avatarGroupLabelSize: AvatarGroupLabelSize,
  avatarProps: Omit<AvatarPropsType, "avatarSize">
}

export const AvatarLabelGroup = memo(forwardRef<HTMLDivElement, AvatarLabelGroupPropsType>((
  {
    avatarGroupLabelSize,
    className,
    avatarProps,
    supportingText,
    label,
    ...props
  }, ref,
) => {
  return (
    <div
      className={classNames(
        className,
        styles.root,
        styles[avatarGroupLabelSize],
      )}
      ref={ref}
      data-avatar-group-label-size={avatarGroupLabelSize}
      {...props}
    >
      <Avatar
        {...avatarProps}
        className={classNames(avatarProps?.className, styles.avatar)}
        avatarSize={avatarGroupLabelSize}
        data-avatar-group-avatar="true"
      />
      <div
        className={styles.label}
        data-avatar-group-label="true"
      >
        <div className={styles.userName}>
          {label ?? avatarProps.userName}
        </div>
        {
          !!supportingText &&
          <div className={styles.supportingText}>
            {supportingText}
          </div>
        }
      </div>
    </div>
  );
}));
